<template>
    <section class="userSteps">
        <Header />
        <div class="d-flex justify-content-end padSpace" @click="store.clearMessage"> <!--v-if="store.error.msg"-->
            <!--  <button type="button" class="close_btn">
                <vue-feather size="26" type="x"></vue-feather>
            </button> -->
        </div>
        <div class="publicProfile row">
            <div class="col-12 d-flex align-items-center justify-content-between mb-4">
                <router-link class="d-flex align-items-center backBtn medium" to="/add-trading-account">
                    <vue-feather class="me-2" type="arrow-left" size="15"></vue-feather> {{ $t('broker_account.text1') }}
                </router-link>
                <div class="counterStep text-end">
                    <p class="mb-0">{{ $t('broker_account.text2') }}</p>
                </div>
            </div>
            <div class="col-12">
                <div class="mainTitle mb-5">
                    <h3 class="mb-3 clash" v-html="$t('broker_account.text3')"></h3>
                    <!-- <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p> -->
                </div>
            </div>
            <div class="col-12 col-lg-6" v-if="store.brokerPlatformList.length">
                <Form class="personalDetails" @submit="submit" autocomplete="off">
                    <div class="form-group position-relative" :class="[{ 'selected': form.platform }]">
                        <Field class="form-select form-control" as="select" name="platform" rules="required"
                            :placeholder="$t('broker_account.text4')" v-model="form.platform"
                            @change="PlatformWiseBrokerList">
                            <!-- <option value="" disabled></option> -->
                            <option v-for="item in store.brokerPlatformList" :key="item.name" :value="item.name">
                                {{ item.name }}</option>
                        </Field>
                        <label class="afterSelect">{{ $t('broker_account.text40') }}</label>
                        <ErrorMessage name="platform" class="text-danger" />
                    </div>
                    <div class="form-group">
                        <div class="brokerSearchList position-relative" :class="[{ 'selected': showbrokers }]">
                            <div class="countrySelect" v-if="form.platform && brokersList.length">
                                <Field class="form-control" name="broker" :placeholder="$t('broker_account.text5')"
                                    v-model="form.broker" rules="required" @keyup="searchBroker" autocomplete="off"
                                    @focus="noTradingAccount = false; showbrokers = !showbrokers;" />
                                <!-- <label class="afterSelect">Broker list</label> -->
                                <vue-feather class="absoluteDown" size="20" :type="!showbrokers ? 'chevron-down' : 'x'"
                                    @click="noTradingAccount = false; showbrokers = !showbrokers;"></vue-feather>
                            </div>
                            <ul class="dropdown_menu_animated scrollable show"
                                v-if="!showbrokers && form.broker && !Object.keys(form.selectedBrokerList).length">
                                <!-- <p>Copy Trading</p> -->
                                <li v-for="list, index in copyTradingList" :key="index">
                                    <a class="d-flex align-items-center justify-content-between"
                                        href="javascript:void(0)" @click="selectBroker(list)">
                                        <span class="d-flex align-items-center f-15 dark"> <img width="40"
                                                class="brokerImg me-2" :src="'https://zulutrade.com/' + list.logoUrl"
                                                :alt="list.logoUrl" :title="list.logoUrl" /> {{ list.name }}</span>
                                        <!-- <span class="semibold f-13 d-flex align-items-center primary"
                                            v-if="list.integrationMode == 'INTEGRATED' || list.integrationMode == 'CO_BRANDED'">{{ $t('broker_account.text42') }}
                                            <span class="infoIcon position-relative ms-1"></span>
                                            <div class="right tooltipbutton">
                                                <span class="tooltiptext">{{ $t('select_broker.text4') }}</span>
                                                <span class="infoIcon position-relative">
                                                    <vue-feather class="opcity ms-1" type="info"
                                                        size="20"></vue-feather>
                                                </span>
                                            </div>
                                        </span> -->
                                    </a>
                                </li>
                            </ul>
                            <ul class="dropdown_menu_animated scrollable show"
                                v-if="showbrokers && getBrokerList.length">
                                <li v-for="list, index in getBrokerList" :key="index">
                                    <a class="d-flex align-items-center justify-content-between"
                                        href="javascript:void(0)" @click="selectBroker(list)">
                                        <span class="d-flex align-items-center f-15 dark"> <img width="40"
                                                class="brokerImg me-2" :src="'https://zulutrade.com/' + list.logoUrl"
                                                :alt="list.logoUrl" :title="list.logoUrl" /> {{ list.name }} </span>
                                    </a>
                                </li>
                            </ul>
                            <ul class="dropdown_menu_animated scrollable p-3 show"
                                v-if="form.broker && !Object.keys(form.selectedBrokerList).length && !copyTradingList.length">
                                <li>
                                    <p class="text-danger mb-0 f-14 d-flex">{{ $t('broker_account.text7') }} <a
                                            class="p-0 mx-1" href="javascript:void(0)"
                                            @click="selectBroker()">{{ $t('broker_account.text7') }}</a>
                                        {{ $t('broker_account.text8') }} </p>
                                </li>
                            </ul>
                        </div>
                        <p class="text-danger mb-0 f-14 d-flex"
                            v-if="form.selectedBrokerList.connectionMethod == 'FETCH_FROM_INTEGRATED_BROKER' && noTradingAccount && !store.getBrokerTradingAccList.length && !manuallyFind">
                            {{ $t('broker_account.text9') }} {{ form.selectedBrokerList.name }}</p>
                    </div>
                    <div class="form-group" v-if="isOtherBroker()">
                        <div class="d-flex justify-content-between mb-4 brokerlinkTab">
                            <a href="javascript:void(0)" class="customButton" @click="tab = 1;form.ip=''" :class="[{'active':tab == 1}]">{{ $t('broker_account.text47') }}</a>
                            <a href="javascript:void(0)" class="customButton" @click="tab = 2;reset()" :class="[{'active':tab == 2}]">{{ $t('broker_account.text48') }}</a>
                        </div>
                        <div class="newOBdrop" v-if="tab==1">
                            <div class="form-group position-relative brokerSearchList" :class="[{'selected':otherBrokerBrokerDrop}]">
                                <div @click="otherBrokerBrokerTrigger()">
                                    <a class="form-control d-flex align-items-center">{{ form.otherBrokerBrokerVal?.length ? form.otherBrokerBrokerVal : $t('broker_account.text49') }}
                                    </a>
                                    <vue-feather class="absoluteDown" size="20" :type="!otherBrokerBrokerDrop ? 'chevron-down' : 'x'"></vue-feather>
                                </div>
                                <ul class="dropdown_menu_animated scrollable show" v-if="otherBrokerBrokerDrop">
                                    <li class="searchDropdown mx-2">
                                        <input type="search" placeholder="Search Broker" class="form-control radiun-0 searchCountry" name="otherBrokerBrokerSearch" v-model="otherBrokerBrokerSearch" />
                                    </li>
                                    <li v-for="list, index in getOtherBrokerFullList" :key="index">
                                        <a class="d-flex align-items-center justify-content-between" href="javascript:void(0)" @click="form.otherBrokerBrokerVal = index;otherBrokerBrokerDrop = false;changeOtherServer()">
                                            <span class="d-flex align-items-center f-15 dark"> {{ index }} </span>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                            <div class="form-group position-relative brokerSearchList" :class="[{'selected':otherBrokerServerDrop}]">
                                <div @click="otherBrokerServerDrop = !otherBrokerServerDrop;otherBrokerBrokerDrop = false">
                                    <a class="form-control d-flex align-items-center">{{ form.otherBrokerServerVal?.length ? form.otherBrokerServerVal : $t('broker_account.text50') }}
                                    </a>
                                    <vue-feather class="absoluteDown" size="20" :type="!otherBrokerServerDrop ? 'chevron-down' : 'x'"></vue-feather>
                                </div>
                                <ul class="dropdown_menu_animated scrollable show" v-if="otherBrokerServerDrop">
                                    <li v-for="list, index in otherBrokerServerList" :key="index">
                                        <a class="d-flex align-items-center justify-content-between" href="javascript:void(0)" @click="form.otherBrokerServerVal = list;otherBrokerServerDrop = false">
                                            <span class="d-flex align-items-center f-15 dark">{{ list }} </span>
                                        </a>
                                    </li>
                                </ul>
                                <span class="text-danger">{{ errorMsg }}</span>
                            </div>
                        </div>
                        <div v-if="tab == 2">
                            <float-label class="countrySelect form-group position-relative"
                                v-if="form.selectedBrokerList.connectionMethod == 'USERNAME_PASSWORD_IP' && !isIpAvailable().length"
                                :class="[{ 'selected': form.ip }]">
                                <Field class="form-control" name="ip" :placeholder="$t('broker_account.text14')"
                                    v-model="form.ip" rules="required" @keydown="onlyNumbersAndDots($event)"/>
                                <!-- <label class="afterSelect">Select IP</label> -->
                                <ErrorMessage name="ip" class="text-danger" />
                            </float-label>
                        </div>
                    </div>
                    <div class="countrySelect form-group position-relative"
                        v-if="!noTradingAccount && store.getBrokerTradingAccList.length && form.selectedBrokerList.connectionMethod == 'FETCH_FROM_INTEGRATED_BROKER'"
                        :class="[{ 'selected': form.tradingAccount }]">
                        <Field class="form-control" as="select" name="trading account" rules="required"
                            placeholder="Trading Account" v-model="form.tradingAccount">
                            <!-- <option value="" disabled>Select Trading Account</option> -->
                            <option v-for="item in store.getBrokerTradingAccList" :key="item.account_id"
                                :value="item.account_id">{{ item.account_id }}</option>
                        </Field>
                        <label class="afterSelect">{{ $t('broker_account.text10') }}</label>
                        <ErrorMessage name="trading account" class="text-danger" />
                    </div>
                    <div class="countrySelect form-group position-relative"
                        v-if="form.selectedBrokerList.connectionMethod == 'USERNAME_PASSWORD_SERVER_CURRENCY' && store.brokerCurrencyList.length"
                        :class="[{ 'selected': form.currency }]">
                        <Field class="form-control" as="select" name="currency" rules="required"
                            v-model="form.currency">
                            <!-- <option value="" disabled>Select Currency</option> -->
                            <option v-for="item in store.brokerCurrencyList" :key="item.id" :value="item.id">
                                {{ item.name }}</option>
                        </Field>
                        <label class="afterSelect">{{ $t('broker_account.text11') }}</label>
                        <ErrorMessage name="currency" class="text-danger" />
                    </div>
                    <div class="countrySelect form-group position-relative"
                        v-if="(form.selectedBrokerList.connectionMethod == 'USERNAME_PASSWORD_SERVER_CURRENCY' || form.selectedBrokerList.connectionMethod == 'USERNAME_PASSWORD_SERVER') && isIpAvailable().length > 1"
                        :class="[{ 'selected': form.server }]">
                        <Field class="form-control" as="select" name="server" rules="required" v-model="form.server">
                            <!-- <option value="" disabled>Select Server</option> -->
                            <option v-for="item in isIpAvailable()" :key="item.addressName" :value="item.addressName">
                                {{ item.addressName }}</option>
                        </Field>
                        <label class="afterSelect">{{ $t('broker_account.text12') }}</label>
                        <ErrorMessage name="server" class="text-danger" />
                    </div>
                    <div class="countrySelect form-group position-relative"
                        v-if="form.selectedBrokerList.connectionMethod == 'USERNAME_PASSWORD_IP' && isIpAvailable().length > 1"
                        :class="[{ 'selected': form.ip }]">
                        <Field class="form-group form-control" as="select" :placeholder="$t('broker_account.text13')"
                            name="ip" rules="required" v-model="form.ip">
                            <!-- <option value="" disabled>Select Server</option> -->
                            <option v-for="item in isIpAvailable()" :key="item.addressName" :value="item.addressName">
                                {{ item.addressName }}</option>
                        </Field>
                        <label class="afterSelect">{{ $t('broker_account.text13') }}</label>
                        <ErrorMessage name="ip" class="text-danger" />
                    </div>
                    <float-label class="countrySelect form-group position-relative"
                        v-if="form.selectedBrokerList.connectionMethod == 'USERNAME_PASSWORD_SERVER_CURRENCY' || form.selectedBrokerList.connectionMethod == 'USERNAME_PASSWORD_IP' || form.selectedBrokerList.connectionMethod == 'USERNAME_PASSWORD_SERVER' || form.selectedBrokerList.connectionMethod == 'USERNAME_PASSWORD' || form.selectedBrokerList.connectionMethod == 'USERNAME' || (form.selectedBrokerList.connectionMethod == 'FETCH_FROM_INTEGRATED_BROKER' && manuallyFind)"
                        :class="[{ 'selected': form.username }]">
                        <Field type="number" class="form-control" name="account username"
                            :placeholder="$t('broker_account.text15')" v-model="form.username" rules="required"
                            autocomplete="new-password" />
                        <!-- <label class="afterSelect">Username</label> -->
                        <ErrorMessage name="account username" class="text-danger" />
                    </float-label>
                    <float-label class="countrySelect form-group"
                        v-if="form.selectedBrokerList.connectionMethod == 'USERNAME_PASSWORD_SERVER_CURRENCY' || form.selectedBrokerList.connectionMethod == 'USERNAME_PASSWORD_IP' || form.selectedBrokerList.connectionMethod == 'USERNAME_PASSWORD_SERVER' || form.selectedBrokerList.connectionMethod == 'USERNAME_PASSWORD' || (form.selectedBrokerList.connectionMethod == 'FETCH_FROM_INTEGRATED_BROKER' && manuallyFind)"
                        :class="[{ 'selected': form.password }]">
                        <div class="position-relative iconInput">
                            <Field class="form-control" :type="inputtype" name="account password"
                                :placeholder="$t('broker_account.text16')" v-model="form.password" rules="required"
                                autocomplete="new-password" />
                            <!-- <label class="afterSelect">Password</label> -->
                            <ErrorMessage name="account password" class="text-danger" />
                            <vue-feather class="position-absolute eye pointer" :type="iconType" size="19"
                                @click="switchVisibility"></vue-feather>
                        </div>
                    </float-label>
                    <div class="mb-2"
                        v-if="form.broker && Object.keys(form.selectedBrokerList).length && form.selectedBrokerList.supportsElectronicLod == true">
                        <label class="customCheckBox line-4">
                            {{ $t('changes.text4') }}
                            <a v-if="checkLOD" download class="primary" :href="lodLink"
                                target="_blank">{{ $t('changes.text5') }}</a>
                            <a v-else-if="form.selectedBrokerList.id == 318" class="primary"
                                :href="`${static_vars.imagePath}/assets/pdf/lodefault.pdf`"
                                target="_blank">{{ $t('changes.text5') }}</a>
                            <span v-else>{{ $t('changes.text5') }}</span>
                            <input type="checkbox" v-model="checkLOD" />
                            <Field type="hidden" name="Letter of Direction" rules="required" v-if="!checkLOD" />
                            <span class="checkmark"></span>
                        </label>
                        <ErrorMessage name="Letter of Direction" class="text-danger" />
                    </div>
                    <p class="manuallyText"
                        v-if="form.broker && Object.keys(form.selectedBrokerList).length && form.selectedBrokerList.connectionMethod != 'GOTO_BROKER' && (!copyTradingList.length || proceedMannual) && (form.selectedBrokerList.id != 289 && form.selectedBrokerList.id != 305)">
                        <!-- Don't Know your account Details? Please click <a href="javascript:void(0);" @click.prevent="raiseQuery = !raiseQuery;SetBroker(form.selectedBrokerList)">here</a> and we'll get back to you. -->
                        {{ $t('broker_account.text17') }} <a class="primary underline" href="javascript:void(0);"
                            @click.prevent="raiseQuery = !raiseQuery; SetBroker(form.selectedBrokerList)">{{ $t('broker_account.text18') }}</a>
                        {{ $t('broker_account.text19') }}.
                    </p>
                    <p class="manuallyText"
                        v-if="form.broker && Object.keys(form.selectedBrokerList).length && (form.selectedBrokerList.id == 289 || form.selectedBrokerList.id == 305) && !raiseQuery && !manuallyFind">
                        {{ $t('broker_account.text20') }} <a href="javascript:void(0);"
                            @click.prevent="proceedMannual = !proceedMannual; selectBroker(form.selectedBrokerList, 'fxViewNoAccount')">{{ $t('broker_account.text18') }}</a>
                        {{ $t('broker_account.text21') }}.
                    </p>
                    <div class="gotoBrokerUnit naturalgray"
                        v-if="form.broker && Object.keys(form.selectedBrokerList).length && form.selectedBrokerList.connectionMethod == 'GOTO_BROKER' && parseInt(form.selectedBrokerList?.id) != 275">
                        <p>{{ `${$t('broker_account.text22')} ${form.selectedBrokerList.name}.
                            ${$t('broker_account.text23')} ${form.selectedBrokerList.name}
                            ${$t('broker_account.text24')}.` }}</p>
                        <p class="semibold mb-1">{{ $t('broker_account.text25') }}:</p>
                        <div class="gotoBroker">
                            <p class="medium"> ”{{ $t('broker_account.text26') }},</p>
                            <p class="mb-0"> {{ $t('broker_account.text27') }} {{ store.customerDetail.firstName || '' }}
                                {{ store.customerDetail.lastName || '' }} {{ $t('broker_account.text28') }}
                                {TRADING_ACCOUNT_ID or USERNAME} {{ $t('broker_account.text41') }}” </p>
                            <button class="copy" type="button" @click="copy(body)"><vue-feather size="25"
                                    type="copy"></vue-feather></button>
                            <span class="coppied" v-if="copyMsg">{{ copyMsg }}</span>
                        </div>
                        <p class="mb-1">{{ $t('broker_account.text29') }}</p>
                        <p class="semibold">{{ $t('broker_account.text30') }}</p>
                        <div class="buttonElement">
                            <a :href="`mailto:${form.selectedBrokerList.brokerNotificationEmails}?cc=partnerships@zulutrade.com&subject=${subject}&body=${body}`"
                                target="_blank"
                                class="grd_btn borderButton d-inline-flex align-items-center justify-content-center"
                                v-if="form.broker && Object.keys(form.selectedBrokerList).length && form.selectedBrokerList.connectionMethod == 'GOTO_BROKER'">
                                <img class="me-2" :src="`${static_vars.imagePath}/assets/images/subtract.svg`"
                                    :alt="$t('broker_account.text31')" /> {{ `${$t('broker_account.text31')}
                                ${form.selectedBrokerList.name}` }} </a>
                        </div>
                    </div>
                    <div class="gotoBrokerUnit naturalgray"
                        v-if="form.broker && Object.keys(form.selectedBrokerList).length && form.selectedBrokerList.connectionMethod == 'GOTO_BROKER' && parseInt(form.selectedBrokerList?.id) == 275">
                        <p>{{ $t('broker_account.text43') }}</p>
                    </div>
                    <div class="buttonElement mb-3">
                        <button type="submit" class="grd_btn full_size" :class="[{ 'disabled': checkConditions() }]"
                            v-if="form.broker && Object.keys(form.selectedBrokerList).length && form.selectedBrokerList.connectionMethod != 'GOTO_BROKER'">
                            {{ $t('broker_account.text32') }}</button>
                    </div>
                    <div class="later text-center mt-4"
                        v-if="form.selectedBrokerList.connectionMethod == 'GOTO_BROKER' && parseInt(form.selectedBrokerList?.id) != 275">
                        <a :href="(store.user.access_token) ? `${static_vars.domainURL}dashboard` : `${static_vars.domainURL}`"
                            :class="(form.broker && Object.keys(form.selectedBrokerList).length && form.selectedBrokerList.connectionMethod == 'GOTO_BROKER') ? 'grd_btn full_size' : 'primary medium f-16'">{{ $t('broker_account.text33') }}</a>
                    </div>
                    <div class="later text-center mt-4"
                        v-if="form.selectedBrokerList.connectionMethod == 'GOTO_BROKER' && parseInt(form.selectedBrokerList?.id) == 275">
                        <a href="https://dashboard-global.bdswiss.com/login" target="_blank"
                            :class="(form.broker && Object.keys(form.selectedBrokerList).length && form.selectedBrokerList.connectionMethod == 'GOTO_BROKER') ? 'grd_btn full_size' : 'primary medium f-16'">{{ $t('broker_account.text44') }}</a>
                    </div>
                </Form>
            </div>
            <div class="col-12 col-lg-6" v-else>
                <span class="f-16">{{ $t('changes.text1') }}</span>
            </div>
            <div class="col-12 col-lg-6">
                <div class="accordion accordion-flush ps-lg-5" id="accordionFlushExample">
                    <h4 class="semibold">{{ $t('broker_account.text34') }}</h4>
                    <div class="accordion-item" v-for="value, key, index in static_vars.connectBrokerFAQ" :key="index">
                        <h2 class="accordion-header" :class="(showfaq == index) ? 'show' : ''">
                            <button class="accordion-button" type="button"
                                @click="(showfaq != index) ? showfaq = index : -1">
                                {{ key }}
                            </button>
                        </h2>
                        <div class="accordion-collapse collapse" :class="(showfaq == index) ? 'show' : ''">
                            <div class="accordion-body graycontent">{{ value }}</div>
                        </div>
                    </div>
                </div>
                <!-- TICKMILL -->
                <tickMill v-if="parseInt(form.selectedBrokerList?.id) == 265"/>
                
            </div>
        </div>
    </section>
    <div class="modal letterDir fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel"
        aria-hidden="true">
        <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header border-0">
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body" v-html="$t('broker_account.text35')">

                </div>
            </div>
        </div>
    </div>

    <!----------------Raise Query-------------------------->
    <div class="modal fade muySellModal" :class="[{ 'show': raiseQuery }]">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header radius20 border-0">
                    <div class="d-flex align-items-center justify-content-center">
                        <div class="toggleSlidebutton d-inline-flex align-items-center justify-content-center">
                            <h6 class="f-24 bold mb-0">{{ $t('broker_account.text36') }}</h6>
                        </div>
                    </div>
                    <button type="button" class="btn-close" @click="raiseQuery = false"></button>
                </div>
                <div class="modal-body pb-2">
                    <div class="specificPrice">
                        <div class="investmentAmount my-2">
                            <!-- <h6 class="mb-2 f-15 regular">Broker</h6> -->
                            <div class="showPrice">
                                <div class="form-group position-relative">
                                    <Form @submit="raiseQueryFunc()">
                                        <float-label class="countrySelect form-group position-relative"
                                            :class="[{ 'selected': query.broker }]">
                                            <Field class="form-control" name="broker name" placeholder=""
                                                v-model="query.broker" rules="required" autocomplete="off" />
                                            <label class="afterSelect">Broker Name</label>
                                            <ErrorMessage name="broker name" class="text-danger" />
                                        </float-label>
                                        <float-label class="countrySelect form-group position-relative"
                                            :class="[{ 'selected': query.brokerUrl }]">
                                            <Field class="form-control" name="broker url" placeholder=""
                                                v-model="query.brokerUrl" autocomplete="off" />
                                            <label class="afterSelect">{{ $t('broker_account.text37')}}</label>
                                            <!-- <ErrorMessage name="broker url" class="text-danger" /> -->
                                        </float-label>
                                        <float-label class="countrySelect form-group position-relative"
                                            :class="[{'selected' : query.info}]">
                                            <Field type="textarea" class="form-control" name="additional info"
                                                placeholder="" v-model="query.info" autocomplete="off" />
                                            <label class="afterSelect">{{$t('broker_account.text38')}}</label>
                                            <!-- <ErrorMessage name="additional info" class="text-danger" /> -->
                                        </float-label>
                                        <div class="buttonElement mb-3">
                                            <button type="submit"
                                                class="grd_btn full_size">{{$t('broker_account.text39')}}</button>
                                        </div>
                                    </Form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Modal TICKMILL -->
</template>

<script>
import $ from "jquery";
import { useMainStore } from "@/store";
import FloatLabel from 'vue-float-label/components/FloatLabel'
import { Form, Field, ErrorMessage } from "vee-validate";
import tickMill from "../../../components/shared/tickmill";
import moment from 'moment';

export default {
    setup() {
        const store = useMainStore();
        return { store };
    },
    data() {
        return {
            form: {
                platform: '',
                broker: '',
                selectedBrokerList: {},
                tradingAccount: '',
                currency: '',
                server: '',
                username: '',
                password: '',
                ip: '',
                otherBrokerBrokerVal: '',
                otherBrokerServerVal: '',
            },
            checkLOD: false,
            noTradingAccount: false,
            isServer: true,
            iconType: "eye-off",
            inputtype: "password",
            showfaq: 0,
            brokersList: [],
            copyTradingList: [],
            showbrokers: false,
            proceedMannual: false,
            raiseQuery: false,
            query: {
                broker: '',
                info: '',
                brokerUrl: ''
            },
            subject: 'ZuluTrade - Account connection request',
            body: `Hello, My name is ${this.store.customerDetail.firstName || ''} ${this.store.customerDetail.lastName || ''} and I would like to move my trading account {TRADING_ACCOUNT_ID or USERNAME} under the ZuluTrade group so that I can copytrade on its platform. Best Regards,`,
            copyMsg: '',
            showpassword: false,
            lodLink: '',
            manuallyFind: false,
            tab: 0,
            otherBrokerBrokerDrop: false,
            otherBrokerBrokerSearch: '',
            otherBrokerServerDrop: false,
            otherBrokerServerList: [],
            errorMsg: '',
        }
    },
    mounted() {
        const _that = this;
        $(document).on("click", function (event) {
            if (!$(event.target).closest(".brokerSearchList").length) {
                _that.showbrokers = false;
                _that.otherBrokerBrokerDrop = false
                _that.otherBrokerServerDrop = false
            }
        });

    },
    components: {
        FloatLabel,
        Form,
        Field,
        ErrorMessage,
        tickMill
    },
    computed: {
        getBrokerList() {
            if (this.showbrokers && this.form.platform && Object.keys(this.store.brokerPlatformList).length) {
                let data = this.store.brokerPlatformList.filter(val => val.name == this.form.platform)[0].brokers;
                if (data.length) {
                    const otherBrokersIndex = data.findIndex((broker) => broker.name.toLowerCase() === "other brokers");
                    if (otherBrokersIndex !== -1 && otherBrokersIndex !== data.length - 1) {
                        const [otherBrokers] = data.splice(otherBrokersIndex, 1);
                        data.push(otherBrokers);
                    }
                    return data
                } else {
                    return []
                }
            } else {
                return []
            }
        },
        getOtherBrokerFullList(){
            let object = this.store.otherBrokerFullList[this.form.platform]
            if(this.otherBrokerBrokerSearch?.length){
                return Object.fromEntries(
                    Object.entries(object).filter(([key]) =>
                        key.toLowerCase().includes(this.otherBrokerBrokerSearch.trim().toLowerCase())
                    )
                ) || []
            } else {
                return object || []
            }            
        }
    },
    watch:{
        "form.otherBrokerServerVal"(){
            if(this.form.otherBrokerServerVal.length) this.errorMsg = ''
        }
    },
    methods: {
        isTodayInRange(){
            let todayDate = moment();
            const startDate = moment('2024-07-01');
            const endDate = moment('2024-07-31');
            return todayDate.isBetween(startDate, endDate);
        },
        copy(text) {
            try {
                navigator.clipboard.writeText(text);
                this.copyMsg = "Copied";
                setTimeout(() => {
                    this.copyMsg = "";
                }, 3000);
            } catch (e) {
                this.copyMsg = "Unable to copy";
                setTimeout(() => {
                    this.copyMsg = "";
                }, 3000);
            }
        },
        SetBroker(list) {
            if (Object.keys(list).length) {
                if (list.name) {
                    if (list.name.toLowerCase() != 'other brokers') {
                        this.query.broker = list.name
                    } else {
                        this.query.broker = ''
                    }
                }
            }
        },
        raiseQueryFunc() {
            let form = {
                'name': this.query.broker
            }
            if (this.query.brokerUrl) {
                form['url'] = this.query.brokerUrl
            }
            if (this.query.info) {
                form['additionalInfo'] = this.query.info
            }
            this.store.brokerRaiseQuery(form, true).then(response => {
                if (response === true) {
                    this.raiseQuery = false
                    this.query = {
                        broker: '',
                        info: '',
                        brokerUrl: ''
                    }
                }
            })
        },
        isIpAvailable() {
            if (Object.keys(this.form.selectedBrokerList).length) {
                let data = [];
                if (this.form.selectedBrokerList.availableServers && this.form.selectedBrokerList.availableServers.length) {
                    this.form.selectedBrokerList.availableServers.forEach(i => {
                        if (i.addressName) {
                            data.push(i)
                        }
                    })
                    if (data.length == 1) {
                        if (this.form.selectedBrokerList.connectionMethod == 'USERNAME_PASSWORD_IP') {
                            this.form.ip = data[0].addressName
                        } else if (this.form.selectedBrokerList.connectionMethod == 'USERNAME_PASSWORD_SERVER' || this.form.selectedBrokerList.connectionMethod == 'USERNAME_PASSWORD_SERVER_CURRENCY') {
                            this.form.server = data[0].addressName
                        }
                    }
                    return data
                } else {
                    return []
                }
            } else {
                return []
            }
        },
        checkConditions() {
            if (!this.form.platform || !this.form.broker || !Object.keys(this.form.selectedBrokerList).length) {
                return true
            } else if (Object.keys(this.form.selectedBrokerList).length) {
                if (parseInt(this.form.selectedBrokerList.id) == 289 || parseInt(this.form.selectedBrokerList.id) == 305) {
                    if (!this.store.getBrokerTradingAccList.length) {
                        if (this.manuallyFind) {
                            return false
                        } else {
                            this.noTradingAccount = true
                            return true
                        }
                    } else {
                        this.noTradingAccount = false
                        return false
                    }
                }

            } else {
                return false
            }
        },
        searchBroker(e) {
            if (this.form.broker) {
                this.noTradingAccount = false
                this.showbrokers = false
                this.form.selectedBrokerList = {}
                this.copyTradingList = []
                let data = this.store.brokerPlatformList.filter(val => val.name == this.form.platform)[0].brokers.filter(item => item.name.split(' ').join('').toLowerCase().includes(e.target.value.toLowerCase()))
                if (data.length) {
                    //this.copyTradingList = data.filter(val => val.availableToCopiers && val.availableToLeaders)
                    data = data.sort(function (a, b) { return b.availableToUser - a.availableToUser });
                    this.copyTradingList = data
                } else {
                    this.copyTradingList = []
                }
            }
        },
        selectBroker(list, type) {
            this.reset()
            if (list && Object.keys(list).length) {
                if (type != 'fxViewNoAccount') {
                    this.showbrokers = false
                    this.manuallyFind = false
                    this.store.$patch({ 'linkBrokerID': list.id })
                    if (list.supportsElectronicLod == true) {
                        this.lod(list.id)
                    }
                    if (parseInt(list.id) == 289 || parseInt(list.id) == 305) {
                        this.form.broker = list.name
                        this.form.selectedBrokerList = list
                        this.copyTradingList = []
                        if (list.connectionMethod == 'FETCH_FROM_INTEGRATED_BROKER') {
                            this.getTradingAccounts(list)
                        }
                    } else if (list.connectionMethod == 'GOTO_BROKER') {
                        this.form.broker = list.name
                        this.form.selectedBrokerList = list
                        this.copyTradingList = []
                        //window.open(list.createAccountLink,'_blank')
                    } else {
                        this.form.ip = ''
                        this.form.broker = list.name
                        this.form.selectedBrokerList = list
                        this.copyTradingList = []
                        if (list.connectionMethod == 'USERNAME_PASSWORD_SERVER_CURRENCY' || list.connectionMethod == 'USERNAME_PASSWORD_SERVER') {
                            this.callBrokerCuurency(list)
                        }
                    }
                } else {
                    this.form.ip = ''
                    this.manuallyFind = true
                    this.form.selectedBrokerList = list
                    this.copyTradingList = []
                }
                if(list.name.toLowerCase() == 'other brokers'){
                    this.store.otherBrokersList({},false)
                    this.tab = 1
                }
            } else {
                this.manuallyFind = false
                this.form.ip = ''
                let data = this.store.brokerPlatformList.filter(val => val.name == this.form.platform)[0].brokers.filter(item => item.name.toLowerCase() == 'other brokers')[0]
                if (data) {
                    this.form.broker = data.name
                    this.form.selectedBrokerList = data
                    this.copyTradingList = []
                    if (data.connectionMethod == 'GOTO_BROKER') {
                        window.open(data.createAccountLink, '_blank')
                    }
                }
            }
        },
        getTradingAccounts(list) {
            this.store.getBrokerTradingAcc({}, true, list.id)
        },
        PlatformWiseBrokerList(e) {
            this.form.broker = ''
            this.form.selectedBrokerList = {}
            if (this.store.brokerPlatformList.length && e?.target?.value) {
                this.brokersList = this.store.brokerPlatformList.filter(val => val.name == e.target.value)[0].brokers
            } else {
                this.brokersList = []
            }
        },
        submit() {
            if(this.isOtherBroker() && this.tab == 1 && !this.form.otherBrokerServerVal){
                this.errorMsg = this.$t('broker_account.text51')
            } else {
                this.errorMsg = ''
                let formdata = {}
                if (this.form.selectedBrokerList.connectionMethod == 'FETCH_FROM_INTEGRATED_BROKER' && !this.manuallyFind) {
                    if (this.store.getBrokerTradingAccList.length) {
                        formdata['accounts'] = [
                            {
                                "account_id": this.form.tradingAccount
                            }
                        ]
                        this.$router.replace('/connect-account')
                        this.store.connectExistingBrokerAccount(formdata, false, this.form.selectedBrokerList.id, this).then((res) => {
                            if (res) {
                                this.store.$patch({ 'acoountconnecting': false })
                                this.store.$patch({ 'linkBrokerStatus': true })
                                // this.store.$patch({ 'isGiftPopup': true })
                            }
                        })
                    }
                } else {
                    formdata['platform'] = this.form.platform
                    formdata['brokerId'] = this.form.selectedBrokerList.id
                    formdata['symbolPattern'] = this.store.brokerSymbolPattern[0]
                    if (this.form.selectedBrokerList.connectionMethod == 'USERNAME_PASSWORD_SERVER_CURRENCY') {
                        formdata['serverName'] = this.form.server  //serverId
                        formdata['userName'] = this.form.username
                        formdata['depositCurrencyId'] = this.form.currency
                        formdata['password'] = this.form.password
                    } else if (this.form.selectedBrokerList.connectionMethod == 'USERNAME_PASSWORD_SERVER') {
                        formdata['serverName'] = this.form.server //serverId
                        formdata['userName'] = this.form.username
                        formdata['password'] = this.form.password
                    } else if (this.form.selectedBrokerList.connectionMethod == 'USERNAME_PASSWORD_IP') {
                        let regex = /\b(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)(?::\d{0,4})?\b/;
                        if(this.isOtherBroker() && this.tab == 1){
                            formdata['serverName'] = this.form.otherBrokerServerVal
                        }else if (regex.test(this.form.ip)) {
                            formdata['ip'] = this.form.ip
                        } else {
                            formdata['serverName'] = this.form.ip
                        }
                        formdata['userName'] = this.form.username
                        formdata['password'] = this.form.password
                    } else if (this.form.selectedBrokerList.connectionMethod == 'USERNAME_PASSWORD') {
                        formdata['userName'] = this.form.username
                        formdata['password'] = this.form.password
                    } else if (this.form.selectedBrokerList.connectionMethod == 'USERNAME') {
                        formdata['userName'] = this.form.username
                    } else if (this.form.selectedBrokerList.connectionMethod == 'FETCH_FROM_INTEGRATED_BROKER') {
                        formdata['userName'] = this.form.username
                        formdata['password'] = this.form.password
                    }
                    this.$router.replace('/connect-account')
                    this.store.connectBroker(formdata, false, this)
                }
            }
        },
        callBrokerList() {
            // let formData = {demo: false, existingBrokerAccount: true, follower: true, forcedBrokerId: 0, pricingSchemeId: 1}
            this.store.getBrokersList({}, true)
        },
        userAccountsList() {
            let form = {
                'grant_type': 'refresh_token',
                'refresh_token': this.store.user.refresh_token
            };
            this.store.refreshToken(form, false, 'basic').then((response) => {
                if (response.access_token) {
                    this.store.getUserAccountsList({}, false)
                }
            })
        },
        callBrokerCuurency(list) {
            if (list.connectionMethod != 'USERNAME_PASSWORD_SERVER') {
                this.store.getBrokerCuurenciesList({}, true, list.id)
            }
            this.store.getBrokerServerList({}, true, list.id)
            this.store.getBrokerSymbolPattern({}, true, list.id)
        },
        switchVisibility() {
            this.showpassword = !this.showpassword;
            if (this.showpassword) {
                this.inputtype = "text";
                this.iconType = "eye";
            } else {
                this.inputtype = "password";
                this.iconType = "eye-off";
            }
        },
        callBrokerWithPlatforms() {
            this.store.getBrokerListwithPlatforms({}, true)
        },
        lod(id) {
            this.store.callLOD({}, false, id).then(res => {
                if (res) { this.lodLink = res }
            })
        },
        isOtherBroker(){
            if(this.form.selectedBrokerList && this.form.selectedBrokerList.name?.toLowerCase() === 'other brokers'){
                return true
            }
            return false
        },
        changeOtherServer() {
            this.form.otherBrokerServerVal = ''
            this.otherBrokerServerList = this.store.otherBrokerFullList[this.form.platform][this.form.otherBrokerBrokerVal] || []
        },
        otherBrokerBrokerTrigger(){
            this.otherBrokerBrokerDrop = !this.otherBrokerBrokerDrop
            this.otherBrokerBrokerSearch = ''
            this.otherBrokerServerDrop = false
        },
        reset(){
            this.form.otherBrokerBrokerVal = ''
            this.form.otherBrokerServerVal = ''
            this.otherBrokerServerList = []
        },
        onlyNumbersAndDots(event) {
            const key = event.key;
            const isNumber = key >= '0' && key <= '9';
            const isDot = key === '.';
            const isControl = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Delete', 'Tab'].includes(key);
            if (!isNumber && !isDot && !isControl) {
                event.preventDefault();
            }
        }
    },

    created() {
        // if(!Object.keys(this.store.brokersList).length){
        this.callBrokerList()
        // }
        this.callBrokerWithPlatforms()
        this.store.$patch({'socketError': null})
    }
}
</script>